// 价格预测

import Vue from 'vue'
import request from '../request'

// 获取地区列表
export function getAreaNameList (params) {
    return request({
        url: Vue.prototype.baseURL + '/rubber/market-price/getAreaNameList',
        method: 'GET',
        params
    })
}
// 获取橡胶类别列表
export function getVarietiesList (params) {
    return request({
        url: Vue.prototype.baseURL + '/rubber/market-price/getVarietiesList',
        method: 'GET',
        params
    })
}

// 根据地区和类别 查询 批发市场下拉列表
export function getMarketList (params) {
    return request({
        url: Vue.prototype.baseURL + '/rubber/market-price/getMarketList',
        method: 'GET',
        params
    })
}
// 价格预测
export function forecastPrice (params) {
    return request({
        url: Vue.prototype.baseURL + '/rubber/market-price/forecastPrice',
        method: 'GET',
        params
    })
}

// 第二步预测 历年数据预测  橡胶批发市场价格分页
export function getMarketPriceList (data) {
    return request({
        url: Vue.prototype.baseURL + '/rubber/market-price/selectListByPage',
        method: 'POST',
        data
    })
}


// 本地 价格模型 预测接口
export function localForecastPriceModel (params) {
    return request({
        url: Vue.prototype.baseURL + '/model/model-application/priceModel',
        method: 'POST',
        params
    })
}

// 文件上传
export function uploadFile (data) {
    return request({
        url: Vue.prototype.baseURL + '/brand/file/upload?folder=localForecastModel',
        method: 'POST',
        data
    })
}



